export var OrderActionTypes;
(function (OrderActionTypes) {
    OrderActionTypes["ORDER_ATTEMPT"] = "ORDER_ATTEMPT";
    OrderActionTypes["ORDER_SUCCESS"] = "ORDER_SUCCESS";
    OrderActionTypes["ORDER_FAILURE"] = "ORDER_FAILURE";
})(OrderActionTypes || (OrderActionTypes = {}));
